import qs from 'qs'

const generateBrowsePageUrl = (refinementList) => {
  const basePath = 'browse'
  const queryString = qs.stringify({ refinementList })
  return `${basePath}/?${queryString}`
}

export default generateBrowsePageUrl
